// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"df266807","246":"0d6922bd"}[chunkId] + ".chunk.css";
};